'use es6';

import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
import { jsx as _jsx } from "react/jsx-runtime";
const SubDropdown = styled(UIButton).withConfig({
  displayName: "VariantSelectOption__SubDropdown",
  componentId: "sc-1oj2c0q-0"
})(["background:transparent !important;padding:0 !important;padding-right:3px !important;min-height:auto !important;&&:hover{background:transparent !important;}"]);
const VariantSelectOption = ({
  dropdownClassName,
  option,
  setOpen,
  onChange,
  OptionComponent,
  VariantButtonComponent,
  VariantOptionComponent,
  VariantSelectComponent
}) => {
  const [isShown, setIsShown] = useState(false);
  const variantOptions = option.variants.map(variant => ({
    name: variant,
    fontValue: {
      fallback: option.fallback,
      font_set: 'CUSTOM',
      font: option.family,
      optionValue: option.value,
      variant,
      styles: Object.assign({}, option.styles[variant])
    },
    svgUrl: option.svgUrls[variant],
    value: variant
  }));
  if (variantOptions.length === 1) {
    const variantOption = variantOptions[0];
    return /*#__PURE__*/_jsx(OptionComponent, {
      onClick: () => {
        onChange({
          target: {
            value: variantOption.value
          }
        }, variantOption);
        setOpen(false);
      },
      children: option.text
    });
  }
  return /*#__PURE__*/_jsx(SubDropdown, {
    onMouseEnter: () => setIsShown(true),
    onMouseLeave: () => setIsShown(false),
    onClick: () => setIsShown(!isShown),
    children: /*#__PURE__*/_jsx(VariantSelectComponent, {
      placeholder: option.text,
      searchable: false,
      placement: "right bottom",
      open: isShown,
      resultsClassName: "variant-select-results",
      onChange: evt => {
        const variantOption = variantOptions.find(variant => variant.value === evt.target.value);
        onChange(evt, variantOption);
      },
      dropdownClassName: `${dropdownClassName} variant-select-dropdown`,
      onSelectedOptionChange: () => setOpen(false),
      options: variantOptions,
      optionRenderer: variant => /*#__PURE__*/_jsx(VariantButtonComponent, {
        use: "transparent",
        children: variant.svgUrl ? /*#__PURE__*/_jsx(UIImage, {
          src: `${variant.svgUrl}`
        }) : /*#__PURE__*/_jsx(VariantOptionComponent, {
          children: variant.name
        })
      })
    })
  });
};
VariantSelectOption.propTypes = {
  dropdownClassName: PropTypes.string,
  option: PropTypes.object.isRequired,
  setOpen: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  OptionComponent: PropTypes.elementType,
  VariantButtonComponent: PropTypes.elementType.isRequired,
  VariantOptionComponent: PropTypes.elementType.isRequired,
  VariantSelectComponent: PropTypes.elementType.isRequired
};
export default VariantSelectOption;